const INTERACTION_EVENTS = [
	'pointerdown',
	'keydown',
	'scroll',
	'touchstart',
] as const;

/**
 * Runs `callback` once, on the visitor's first tap, click, keypress or scroll.
 * Returns a function that stops listening without running it.
 */
export const onFirstInteraction = (callback: () => void): (() => void) => {
	const stopListening = () => {
		for (const event of INTERACTION_EVENTS) {
			window.removeEventListener(event, handleInteraction);
		}
	};

	function handleInteraction() {
		stopListening();
		callback();
	}

	for (const event of INTERACTION_EVENTS) {
		window.addEventListener(event, handleInteraction, { passive: true });
	}

	return stopListening;
};
